import axiosConfig from "./axiosConfig";

const deleteSiteHealthConfig = async (
  authToken: string,
  siteId: string
): Promise<void> => {
  await axiosConfig.delete(`/site/${siteId}/health/config`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
};

export default deleteSiteHealthConfig;
